import { useContext } from "react";
import { AppMainStateContext } from "../../contexts/AppMainStateContext";

const NewMovieCardSkeleton = () => {
  const { isMobile } = useContext(AppMainStateContext);

  return (
    <div className={`${isMobile ? "h-56 aspect-[14/10]" : "h-80 md:aspect-[13/9]"}`}>
      <div className="animate-pulse flex flex-col space-y-2">
        <div className="aspect-video bg-neutral-700 rounded-lg"></div>
        <div className="w-3/4 bg-neutral-700 h-3 md:h-5 rounded-xl"></div>
        <div className="w-1/4 bg-neutral-700 h-3 md:h-5 rounded-xl"></div>
      </div>
    </div>
  );
};
export default NewMovieCardSkeleton;
